// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { KeycloakConfig } from "keycloak-js";
const keycloakConfig: KeycloakConfig = {
  url: 'https://services.ahyush.com:8443/oauth-authorization-server/auth',
  realm: 'ahyush',
  clientId: 'angular-talktodoctor',
};
export const environment = {
  production: true,
  restAPIUrl: 'https://services.ahyush.com:8443/ayurls-doctor',
  restLoginUrl:'https://services.ahyush.com:8443/ahyush-services',
  ahyushUrl: 'https://ahyush.com/app/home',
  ahyushLoginUrl: 'https://ahyush.com/app/login',
  baseUrl: 'https://als.ahyush.com',
  OAuthApiUrl:'https://services.ahyush.com:8443/oauth-authorization-server',
  keycloak: keycloakConfig
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
